module.exports = __webpack_public_path__ + "img/55.0d0ac9db.jpg";